import React, { useEffect } from "react"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addFrame, getAllFrames, checkFrameCodeExists, getClinicById, getClinic } from "service/api"
import Select from 'react-select';

import debounce from "lodash.debounce";

import DatatableTables from "./FramesStocks";
import { jwtDecode } from "jwt-decode"


const defaultValue = {
  fcode: "",
  fname: "",
  fqty: "",
  clinicid: "",
}

const AddFrame = () => {
  const [frame, setFrame] = useState(defaultValue);
  const [errors, setErrors] = useState({});
  const [frameNames, setFrameNames] = useState([]);
  const [refreshTable, setRefreshTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [allcliniclist, setallclinic] = useState([]);
  const navigate = useNavigate();
  const [patient, setPatient] = useState(defaultValue);
  const [clinicID, setClinicID] = useState(null);

  const frameOptions = frameNames.map((f) => ({
    value: f.frame_name,
    label: f.frame_code ? `${f.frame_title} (${f.frame_code})` : f.frame_title,
    frame_code: f.frame_code || "",
    frame_title: f.frame_title,
  }));

  useEffect(() => {
    document.title = "Frames | Add Frames";
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    // if (token) {
    //   const decoded = jwtDecode(token);
    //   setClinicID(decoded?.clinicID || null);
    // }
    if (token) {
      const decoded = jwtDecode(token);
      const id = decoded?.clinicID || null;
      setClinicID(id);

      // ✅ Set frame.clinicid here
      if (id) {
        setFrame(prev => ({ ...prev, clinicid: id }));
      }
    }
    const fetchFrames = async () => {
      try {
        const response = await getAllFrames();
        setFrameNames(response.data?.data || []);
      } catch (error) {
        console.error("Error fetching frame names:", error);
      }
    };


    fetchFrames();
    getallclinic();
  }, []);

  const debouncedCheckFcode = debounce(async (fcode) => {
    try {
      const res = await checkFrameCodeExists(fcode);
      if (res.data.exists) {
        setErrors(prev => ({ ...prev, fcode: "Frame code already exists" }));
      }
    } catch (err) {
      console.error("Error checking frame code:", err);
    }
  }, 500);

  const onValueChange = (e) => {
    const { name, value } = e.target;
    setFrame(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }

    if (name === "fcode" && value.trim()) {
      debouncedCheckFcode(value.trim());
    }
  };

  const validate = () => {
    const formErrors = {};
    if (!frame.fcode.trim()) formErrors.fcode = "Frame code is required";
    if (!frame.fname.trim()) formErrors.fname = "Frame name is required";
    if (!frame.clinicid.trim()) formErrors.clinicid = "clinic name is required";
    if (errors.fcode === "Frame code already exists") formErrors.fcode = errors.fcode;
    if (!frame.fqty.trim()) formErrors.fqty = "Quantity is required";
    else if (isNaN(frame.fqty) || Number(frame.fqty) < 0) formErrors.fqty = "Quantity must be a valid number";


    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // const handleAddFrame = async (e) => {
  //   e.preventDefault();
  //   if (!validate()) return;

  //   try {
  //     await addFrame(frame);
  //     toast.success("Frame added successfully", { position: "top-center", autoClose: 1500 });
  //     navigate("/frames");
  //   } catch (error) {
  //     if (error.response?.status === 409) {
  //       setErrors(prev => ({ ...prev, fcode: "Frame code already exists" }));
  //     } else {
  //       toast.error("Failed to add frame");
  //       console.error("Add error:", error);
  //     }
  //   }
  // };

  const getallclinic = async () => {
    try {
      let response;
      if (clinicID) {
        response = await getClinicById(clinicID);
        setallclinic([response.data]);
      } else {
        response = await getClinic();
        setallclinic(response.data);
      }
    } catch (err) {
      console.error("Error fetching clinic(s)", err);
    }
  };

  const handleAddFrame = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // start loading

    try {
      await addFrame(frame);

      toast.success("Frame added successfully", {
        position: "top-center",
        autoClose: 1500,
      });

      // ✅ Clear form and errors
      setFrame(defaultValue);
      setErrors({});

      // ✅ Refresh the datatable
      setRefreshTable((prev) => !prev);
    } catch (error) {
      if (error.response?.status === 409) {
        setErrors((prev) => ({
          ...prev,
          fcode: "Frame code already exists",
        }));
      } else {
        toast.error("Failed to add frame");
        console.error("Add error:", error);
      }
    } finally {
      setLoading(false); // stop loading
    }
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Frames Stock</h4>
            {/* <Link to="/frames" className="btn btn-danger">Frames</Link> */}
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Practice Name
                        </Label>
                        <select
                          name="clinicid"
                          className="form-control"
                          onChange={onValueChange}
                          value={frame.clinicid} // ✅ Fix here
                          disabled={!!clinicID}
                        >
                          {!clinicID && <option value="">Choose...</option>}
                          {allcliniclist.map((clinic) => (
                            <option key={clinic._id} value={clinic._id}>
                              {clinic.name}
                            </option>
                          ))}
                        </select>

                      </div>
                      {errors.clinicid && (
                        <div className="invalid-feedback">{errors.clinicid}</div>
                      )}
                    </Col>
                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Frame Code<span style={{ color: "red" }}>*</span>
                        </Label><Input
                          type="text"
                          name="fcode"
                          value={frame.fcode} // ✅ ADD THIS
                          className={`form-control ${errors.fcode ? "is-invalid" : ""}`}
                          placeholder="Enter Frame Code"
                          onChange={onValueChange}
                        />

                        {errors.fcode && (
                          <div className="invalid-feedback">{errors.fcode}</div>
                        )}
                      </div>
                    </Col>

                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-login">
                          Frame Name<span style={{ color: "red" }}>*</span>
                        </Label>

                        <Select
                          name="fname"
                          classNamePrefix="react-select"
                          className={errors.fname ? "is-invalid" : ""}
                          options={frameOptions}
                          value={
                            frame.fname
                              ? frameOptions.find((option) => option.value === frame.fname) || {
                                value: frame.fname,
                                label: frame.fname,
                              }
                              : null
                          }
                          onChange={(selectedOption) => {
                            setFrame((prev) => ({
                              ...prev,
                              fname: selectedOption ? selectedOption.value : "",
                              fcode: selectedOption?.frame_code || "",
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              fname: "",
                              fcode: "",
                            }));
                          }}
                        />


                        {errors.fname && (
                          <div className="invalid-feedback d-block">{errors.fname}</div>
                        )}
                      </div>
                    </Col>

                    <Col lg={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-quantity">
                          Quantity<span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="number"
                          name="fqty"
                          value={frame.fqty}
                          className={`form-control ${errors.fqty ? "is-invalid" : ""}`}
                          placeholder="Enter Quantity"
                          onChange={onValueChange}
                          min="0"
                        />
                        {errors.fqty && (
                          <div className="invalid-feedback">{errors.fqty}</div>
                        )}
                      </div>
                    </Col>


                  </Row>
                  <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddFrame}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>

                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>

          <DatatableTables refresh={refreshTable} />
        </Container>
      </div>
    </React.Fragment>
  );

}

export default AddFrame;
